import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/login/auth.service';

@Injectable()
export class TokenRefreshInterceptor implements HttpInterceptor {

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          // Gestione errori di autenticazione (solo 401 Unauthorized)
          // 403 Forbidden viene propagato al componente per mostrare l'errore
          if (error.status === 401) {
            return this.handleSessionExpired();
          }
        }
        return throwError(() => error);
      })
    );
  }

  /**
   * Gestisce la sessione scaduta: pulisce i dati e reindirizza al login
   */
  private handleSessionExpired(): Observable<never> {
    this.auth.logout();

    this.clearCachedData();

    console.warn('Sessione scaduta. Redirect al login.');
    this.router.navigate(['/login'], {
      replaceUrl: true,
      queryParams: { sessionExpired: 'true' }
    });

    return EMPTY;
  }

  /**
   * Pulisce i dati cached dell'applicazione
   */
  private clearCachedData(): void {
    const keysToRemove = [
      'climacloud.interventi.flat.v1',
      'climacloud.interventi.group.v1',
      'climacloud.sos_state.v1',
      'climacloud.devicelist_state.v1',
      'climacloud.scadenze.v1',
      'climacloud.documenti.v1'
    ];

    keysToRemove.forEach(key => {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        // Ignora errori di localStorage
      }
    });
  }
}
